import { COMPANY_DIRECTORY_SOURCE } from '@savgroup-front-common/types/CompanyDirectory';

import {
  OnboardingActivitiesLocationState,
  PickedCompany,
} from '../OnboardingActivities.types';

function adaptPickedCompany(pickedCompany: unknown): PickedCompany | undefined {
  if (typeof pickedCompany !== 'object' || !pickedCompany) {
    return undefined;
  }

  const source =
    'source' in pickedCompany
      ? Object.values(COMPANY_DIRECTORY_SOURCE).find(
          (directorySource) => directorySource === pickedCompany.source,
        )
      : undefined;
  const registrationNumber =
    'registrationNumber' in pickedCompany &&
    typeof pickedCompany.registrationNumber === 'string'
      ? pickedCompany.registrationNumber
      : undefined;

  if (!source || !registrationNumber) {
    return undefined;
  }

  return { source, registrationNumber };
}

export function adaptLocationState(
  state: unknown,
): OnboardingActivitiesLocationState {
  if (typeof state !== 'object' || !state) {
    return {};
  }

  return {
    companyName:
      'companyName' in state && typeof state.companyName === 'string'
        ? state.companyName
        : undefined,
    pickedCompany:
      'pickedCompany' in state
        ? adaptPickedCompany(state.pickedCompany)
        : undefined,
  };
}
